import DefaultColumn from "components/Table/components/DefaultColumn";
import { currency } from "helper/index";
import moment from "moment";
import "moment/locale/id";

moment.locale("id");
const TABLE_COLUMN = [
  {
    accessorKey: "deposit_method",
    header: "Metode Deposit",
    cell: (info) => (
      <DefaultColumn>
        {{ 1: "Teller", 2: "Cash", 3: "Transfer" }?.[info.getValue()] ?? "-"}
      </DefaultColumn>
    ),
    size: 500,
  },
  {
    accessorKey: "user_sales.sales_name",
    header: "Nama Sales",
    cell: (info) => <DefaultColumn>{info.getValue()}</DefaultColumn>,
  },
  {
    accessorKey: "deposit_date",
    header: "Tanggal Deposit",
    cell: (info) => (
      <DefaultColumn>
        {moment(info.getValue()).format("DD MMMM YYYY HH:mm")}
      </DefaultColumn>
    ),
  },
  {
    accessorKey: "total_amount",
    header: "Total Amount",
    cell: (info) => <DefaultColumn>{currency(info.getValue())}</DefaultColumn>,
  },
];

export { TABLE_COLUMN };
